import { keyframes } from '@mui/material';
import type { Styles } from 'common/types';
import { type CSSProperties } from 'react';

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const styles: Styles = {
  collageWrapper: {
    position: 'relative',
    height: 280,
    width: '100%',
    maxWidth: 1250,
    borderRadius: 4,
    overflow: 'hidden',
    mb: 4,
    display: 'flex',
    gap: 1,
    filter: 'drop-shadow(1px 3px 10px rgba(21, 30, 34, 0.09))',
  },
  colSmallest: {
    display: 'flex',
    flexBasis: '15%',
    flexDirection: 'column',
    gap: 1,
    height: '100%',
  },
  colMedium: { flex: '2 30%', overflow: 'hidden', position: 'relative' },
  colLarge: {
    flex: '3 40%',
    overflow: 'hidden',
    borderRadius: '0 16px 16px 0',
    position: 'relative',
  },
  imageBox: {
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#e3f2fd',
  },
  badgeInfo: {
    position: 'absolute',
    top: 10,
    left: 10,
    fontSize: '4rem',
    fontWeight: 'bold',
    zIndex: 2,
    color: '#FFF',
    filter: 'drop-shadow(0 0 2px #000)',
    opacity: 0.6,
    lineHeight: 1,
  },
  emptyPlaceholder: {
    height: '100%',
    width: '100%',
    background: 'linear-gradient(-45deg, #e0e0e0, #cfd8dc, #eeeeee, #b0bec5)',
    backgroundSize: '400% 400%',
    animation: `${gradientAnimation} 5s ease infinite`,
    boxShadow: 'inset 0px 4px 10px rgba(0, 0, 0, 0.05)',
  },
};

export const nativeStyles: Record<string, CSSProperties> = {
  imageElement: {
    objectFit: 'cover',
    objectPosition: 'center',
    height: '100%',
    width: '100%',
    borderRadius: 'inherit',
    display: 'block',
  },
};
